import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { SsoSetting } from 'bookraw/shared/models/sso-setting.model';
import { ItemResponse } from 'bookraw/shared/models/api/item.response';
import { environment } from 'env/environment';

@Injectable()
export class SsoSettingsService extends ListService<SsoSetting> {

  url: string = '/api/admin/ssoSettings';

  sync(id: number, ssoSchoolId: string, districtId: string = null) {
    return this.http.post(environment.baseURL + this.url + '/' + id + '/sync', {'ssoSchoolId': ssoSchoolId, 'districtId': districtId});
  }

  status(id: number, ssoSchoolId: string) {
    return this.http.get(environment.baseURL + this.url + '/' + id + '/sync', {params: {'ssoSchoolId': ssoSchoolId}})
  }
}
